import { render, staticRenderFns } from "./cDocumentVersionCompare.vue?vue&type=template&id=a7c2ef28&scoped=true"
import script from "./cDocumentVersionCompare.vue?vue&type=script&lang=js"
export * from "./cDocumentVersionCompare.vue?vue&type=script&lang=js"
import style0 from "./cDocumentVersionCompare.vue?vue&type=style&index=0&id=a7c2ef28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c2ef28",
  null
  
)

export default component.exports